import React from 'react';
import { ChevronLeft } from 'lucide-react';

const Header = ({ navigate, models, primaryModel, setPrimaryModel, secondaryModel, setSecondaryModel }) => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md mb-6">

      {/* Model Selection */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Primary Model</label>
          <select
            value={primaryModel}
            onChange={(e) => setPrimaryModel(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
          >
            {models.map((model) => (
              <option key={model.key} value={model.name}>
                {model.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Secondary Model</label>
          <select
            value={secondaryModel}
            onChange={(e) => setSecondaryModel(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
          >
            {models.map((model) => (
              <option key={model.key} value={model.name}>
                {model.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Header;